const searchUsersKeys = {
  default: ["users"],
  user: (search) => [...searchUsersKeys.default, search],
};
export { searchUsersKeys };
